import { appendEntryCourseSlug } from '#app/domains/enrollments/application/entryStrategyParams'
import { path } from '#app/utils/pz/routes.generated'

type LeadMagnetLike = {
	enabled: boolean
	collectionId: string | null
}

type LeadMagnetSignupTargetParams = {
	leadMagnet?: LeadMagnetLike | null
	explicitCollectionId?: string | null
	redirectTo?: string
	entryCourseSlug?: string | null
}

type SignupTargetParams = {
	collectionId?: string | null
	redirectTo?: string
	entryCourseSlug?: string | null
}

function normalizeOptionalText(value: unknown): string | null {
	if (typeof value !== 'string') return null
	const normalized = value.trim()
	return normalized.length > 0 ? normalized : null
}

export function resolveLeadMagnetCollectionId(
	params: LeadMagnetSignupTargetParams = {},
): string | null {
	const explicitCollectionId = normalizeOptionalText(
		params.explicitCollectionId,
	)
	if (explicitCollectionId) return explicitCollectionId

	const configuredCollectionId = normalizeOptionalText(
		params.leadMagnet?.collectionId,
	)
	return params.leadMagnet?.enabled ? configuredCollectionId : null
}

export function buildLeadMagnetSignupTarget(
	params: LeadMagnetSignupTargetParams = {},
): string {
	return buildSignupTarget({
		collectionId: resolveLeadMagnetCollectionId(params),
		redirectTo: params.redirectTo,
		entryCourseSlug: params.entryCourseSlug,
	})
}

export function buildSignupTarget(params: SignupTargetParams = {}): string {
	const searchParams = new URLSearchParams()
	const collectionId = normalizeOptionalText(params.collectionId)

	if (collectionId) {
		searchParams.set('collectionId', collectionId)
	}

	appendEntryCourseSlug(searchParams, params.entryCourseSlug)
	searchParams.set('redirectTo', params.redirectTo ?? path('studyPanel.base'))
	return `${path('auth.signup')}?${searchParams.toString()}`
}
